import { FC, useState } from "react";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { HotkeysProvider } from "@blueprintjs/core";

import { LoadingScreen } from "@components/LoadingScreen";
import { queryClient } from "@lib";

import { FindingFiltersProvider } from "./FindingFiltersProvider";
import { MantineApp } from "./MantineApp";
import { OrgProvider } from "./OrgProvider";
import { PermissionsProvider } from "./PermissionsProvider";
import { TimeLookbackProvider } from "./TimeLookbackProvider";
import { UserProvider } from "./UserProvider";

// TODO: Remove Hotkeys provider after we nuke Blueprint
export const AppProvider: FC = ({ children }) => {
  const [orgFeaturesLoaded, setOrgFeaturesLoaded] = useState<boolean>(true);
  const [permissionsLoaded, setPermissionsLoaded] = useState<boolean>(true);

  return (
    <HotkeysProvider>
      <QueryClientProvider client={queryClient}>
        <MantineApp>
          <UserProvider>
            <OrgProvider
              setOrgFeaturesLoaded={setOrgFeaturesLoaded}
              setPermissionsLoaded={setPermissionsLoaded}
            >
              <PermissionsProvider
                permissionsLoaded={permissionsLoaded}
                setPermissionsLoaded={setPermissionsLoaded}
              >
                <FindingFiltersProvider>
                  <TimeLookbackProvider>
                    {!orgFeaturesLoaded || !permissionsLoaded ? (
                      <LoadingScreen />
                    ) : (
                      children
                    )}
                    {process.env.NODE_ENV === "development" && (
                      <ReactQueryDevtools
                        initialIsOpen={false}
                        position="bottom-right"
                      />
                    )}
                  </TimeLookbackProvider>
                </FindingFiltersProvider>
              </PermissionsProvider>
            </OrgProvider>
          </UserProvider>
        </MantineApp>
      </QueryClientProvider>
    </HotkeysProvider>
  );
};
